export default __webpack_public_path__ + "assets/images/mock-ad-image-building_3Ai1_.jpg";